import React, { useEffect, useState } from "react"
import SvgSupport from "@Components/CustomIcon/SvgSupport"
import CustomSettingTitle from "@Components/CustomSettingTitle/CustomSettingTitle"
import { View } from "react-native"
import { Divider, List } from "react-native-paper"
import SvgNext from "@Components/CustomIcon/SvgNext"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import SvgSupportBlank from "@Components/CustomIcon/SvgSupportBlank"
import SvgBug from "@Components/CustomIcon/SvgBug"
import SvgIdea from "@Components/CustomIcon/SvgIdea"
import SvgOthers from "@Components/CustomIcon/SvgOthers"
import { useNavigation } from "@react-navigation/core"
import { useSetRecoilState } from "recoil"
import { navigationAtom } from "@Recoil/navigationAtom"
import { ModalCreateFeedBack } from "./FeedBack/ModalCreateFeedBack"
import { FeedbackService } from "@Services/FeedBack.Service"
import styles from "./styles"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { FeedbackTypes } from "@Constants/constant"
import { Spacer } from "../../../Components/Space"

const SupportAndHelp = () => {
    const navigation = useNavigation()
    const setNavigationState = useSetRecoilState(navigationAtom)
    const [modalFeedbackOpen, setModalFeedbackOpen] = useState(false)
    const [isModalVisible, setModalVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [feedbackTypes, setFeedbackTypes] = useState([])
    const [feedbackTypeSelected, setFeedbackTypeSelected] = useState(null)
    const rightIcon = () => <List.Icon style={{ paddingLeft: 40 }} icon={() => <SvgNext />} />

    const navigateTo = (nextScreen) => {
        setNavigationState(nextScreen)
        navigation.navigate(nextScreen)
    }
    const toggleModal = (value) => setModalVisible(value)

    const supportItems = [
        {
            title: "Une question ?",
            description: "Contactez-nous",
            onPress: () => toggleModal(true)
        },
        {
            title: "Aide",
            description: "Consultez notre FAQ",
            onPress: () => navigateTo("FAQ")
        },
        {
            title: "RGPD",
            description: "Recueil de consentement",
            onPress: () => navigateTo("Consent")
        },
        {
            title: "CGU",
            description: "Politique de confidentialité",
            onPress: () => navigateTo("PersonalData")
        }
    ]

    const fetchFeedbackTypes = () => {
        setLoading(true)
        FeedbackService.getTypes()
            .then((response) => {
                const data = response.data?.data

                console.log({ data })

                if (data) {
                    setFeedbackTypes(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
                ShowToast({
                    type: "error",
                    message: "Une erreur est survenue lors de la recupération des types de feedback !"
                })
            })
    }

    const handleSelectedType = (type) => {
        const feedbackType = feedbackTypes.filter((item) => item.name === type)
        if (feedbackType.length > 0) {
            setFeedbackTypeSelected(feedbackType[0])
            toggleModal(false)
            setModalFeedbackOpen(true)
        } else {
            alert("Type de feedback manquant")
        }
    }
    const createFeedBackTechnicalProblem = () => {
        handleSelectedType(FeedbackTypes.TECHNICAL_PROBLEM)
    }

    const createFeedBackSuggestion = () => {
        handleSelectedType(FeedbackTypes.SUGGESTION)
    }

    const createFeedBackOther = () => {
        handleSelectedType(FeedbackTypes.OTHER)
    }

    const createFeedBackQuestion = () => {
        handleSelectedType(FeedbackTypes.QUESTION)
    }

    const contactUsItems = [
        {
            title: "Besoin d’aide",
            svgIcon: <SvgSupportBlank />,
            onPress: () => createFeedBackQuestion()
        },
        {
            title: "Problème technique",
            svgIcon: <SvgBug />,
            onPress: () => createFeedBackTechnicalProblem()
        },
        {
            title: "Suggestion d’amélioration",
            svgIcon: <SvgIdea />,
            onPress: () => createFeedBackSuggestion()
        },
        {
            title: "Autre",
            svgIcon: (
                <View style={{ marginTop: 10 }}>
                    <SvgOthers />
                </View>
            ),
            onPress: () => createFeedBackOther()
        }
    ]

    useEffect(() => {
        fetchFeedbackTypes()
    }, [])

    return (
        <View style={styles.container}>
            <ModalCreateFeedBack
                feedbackType={feedbackTypeSelected}
                openModal={modalFeedbackOpen}
                toggleModal={() => setModalFeedbackOpen(false)}
            />

            <CustomSettingTitle
                title="Aide et support"
                subTitle="N'hésitez pas à nous contacter."
                icon={<SvgSupport />}
            />

            <Spacer />

            <View style={styles.content}>
                <List.Section>
                    {supportItems.map((item, index) => {
                        const showDivider = index !== supportItems.length - 1
                        return (
                            <View key={index}>
                                <List.Item
                                    style={styles.item}
                                    title={item.title}
                                    titleStyle={styles.titleStyle}
                                    description={item.description}
                                    descriptionStyle={styles.descriptionStyle}
                                    right={rightIcon}
                                    onPress={() => (index > 0 ? item.onPress() : loading ? {} : item.onPress())}
                                />
                                {showDivider && <Divider style={styles.divider} />}
                            </View>
                        )
                    })}
                </List.Section>
            </View>

            <CustomBottomModal title="Contactez-nous" toggleModal={() => toggleModal(false)} open={isModalVisible}>
                <List.Section>
                    {contactUsItems.map((item, index) => {
                        const showDivider = index !== contactUsItems.length - 1
                        return (
                            <View key={index}>
                                <List.Item
                                    style={styles.contactUsItem}
                                    title={item.title}
                                    titleStyle={styles.contactUsTitle}
                                    left={() => item.svgIcon}
                                    onPress={() => item.onPress()}
                                />
                                {showDivider && <Divider style={styles.divider} />}
                            </View>
                        )
                    })}
                </List.Section>
            </CustomBottomModal>
        </View>
    )
}

export default SupportAndHelp
